/* Live catalogue injected by Liquid, keyed by product handle. */
const SHOP=window.FARO_SHOPIFY||{};
/* Shopify CDN URLs carry a width= parameter; ask for a smaller file where a small image is all we show. */
function pimg(p,i,w){const u=(p.images&&(p.images[i]||p.images[0]))||''; return (w&&/[?&]width=\d+/.test(u))?u.replace(/([?&]width=)\d+/,'$1'+w):u;}


/* thread palette — light flag drives blend mode */
const THREADS=[
  {id:'red',   name:'Red',          hex:'#D01C2B'},
  {id:'orange',name:'Orange',       hex:'#DD8046'},
  {id:'yellow',name:'Yellow',       hex:'#DFDB74'},
  {id:'ltgrn', name:'Light Green',  hex:'#B2D8B8'},
  {id:'hunter',name:'Hunter Green', hex:'#52792F'},
  {id:'ltblue',name:'Light Blue',   hex:'#45A0DB'},
  {id:'navy',  name:'Navy',         hex:'#17356B'},
  {id:'pink',  name:'Pink',         hex:'#EA4C89'},
  {id:'brown', name:'Brown',        hex:'#7C4C2E'},
  {id:'black', name:'Black',        hex:'#1A1A1A'},
  {id:'white', name:'White',        hex:'#F7F7F5'},
  {id:'silver',name:'Silver',       hex:'#ABAFB2'}
];
/* Blend mode follows the thread's own brightness, so new colours need no hand-tuning. */
THREADS.forEach(t=>{
  const n=parseInt(t.hex.slice(1),16), r=n>>16&255, g=n>>8&255, b=n&255;
  t.light = (0.299*r + 0.587*g + 0.114*b)/255 > 0.62;
});

/* placement zones are % of the photo — tune live with the C panel */
/* Brother PR650e — nothing on this site can exceed the machine's usable field.
   Sewing field is 300 x 200 mm and it is FIXED; a bigger hoop buys registration, not area.
   (The NECCHI's 160 x 260 was the old ceiling — it is still in service for small work,
   but the site quotes the larger machine because Faro can choose which one runs the job.) */
const HOOP={maxW:300,maxH:200,minW:50,minH:70,label:'300 × 200 mm',small:'50 × 70 mm'};
/* mm = stitched width of a 6-character name at Medium. mmMax = the practical cap for that
   placement, already inside the hoop. frameMM = real width the whole photo spans. */
const PRODUCTS=[
  {id:'sweatshirt', handle:'bridal-sweatshirt', frameMM:720, name:'The Sweatshirt', sub:'Gildan 18000 heavy blend fleece · white', dark:false,
   places:{'Center chest':{x:50,y:41,mm:121,mmMax:160,r:0},'Left chest':{x:60.5,y:36.5,mm:70,mmMax:100,r:0}}, sizes:['S','M','L','XL']},
  {id:'tank', handle:'coastal-tank', frameMM:560, name:'The Tank', sub:'Gildan 64200L soft-spun cotton · white', dark:false,
   places:{'Center chest':{x:50,y:43.5,mm:80,mmMax:120,r:0}}, sizes:['S','M','L','XL']},
  {id:'shorts', handle:'sweat-shorts', frameMM:470, name:'The Sweat Shorts', sub:'TriDri TD062 brushed-back fleece · white', dark:false,
   places:{'Left leg':{x:64.5,y:65,mm:64,mmMax:90,r:-12}}, sizes:['S','M','L','XL']},
  {id:'bib', handle:'baby-bib', frameMM:260, name:'The Baby Bib', sub:'Rabbit Skins 1005 premium jersey · one size', dark:false,
   /* colour ids are internal; name must match the Shopify variant option value exactly.
      Never put a "/" in a colour name — variantFor() splits variant titles on "/". */
   colors:[{id:'white',name:'White',hex:'#FFFFFF'},
           {id:'ltblue',name:'Light Blue',hex:'#A8C8E0'},
           {id:'royal',name:'Royal',hex:'#1F3FA8'},
           {id:'wht-ltblue',name:'White & Light Blue',hex:'#FFFFFF',trim:'#A8C8E0'},
           {id:'wht-royal',name:'White & Royal',hex:'#FFFFFF',trim:'#1F3FA8'}],
   places:{'Center front':{x:50,y:57.5,mm:60,mmMax:60,r:0}}},
  /* Blanket 'Corner' CALIBRATED by Dana Sept 14; 'Center' is still an estimate. */
  {id:'blanket', handle:'baby-blanket', frameMM:700, name:'The Baby Blanket', sub:'Silk-touch fleece · 30 × 40 in', dark:false,
   places:{'Corner':{x:66,y:72,mm:119,mmMax:150,r:0}}},
  /* Tote and towel placements CALIBRATED by Dana, Sept 14, against the real photos.
     mmMax is a hard cap — paint() renders min(mm, mmMax, HOOP.maxW) — so mmMax is always >= mm,
     otherwise the mm figure never does anything and every name renders at the cap.
     The Q600 advertises a 356 mm decoration area — that is the bag, not the hoop. */
  {id:'tote', handle:'jumbo-tote', frameMM:640, name:'The Tote', sub:'Q-Tees Q600 cotton canvas · white · 20 × 15 in', dark:false,
   places:{'Center top':{x:50,y:44,mm:107,mmMax:260,r:0},'Right corner':{x:72,y:42,mm:79,mmMax:110,r:0}}},
  {id:'towel', handle:'hooded-towel', frameMM:700, name:'The Baby Hooded Towel', sub:'Cotton terry · 36 × 36 in', dark:false,
   places:{'Hood':{x:50,y:41,mm:160,mmMax:160,r:0}}},
  {id:'spabag', handle:'waffle-spa-bag', frameMM:300, name:'The Diaper Bag', sub:'Liberty Bags 5770 cotton waffle weave', dark:false,
   places:{'Front panel':{x:50,y:49,mm:76,mmMax:100,r:0}}},
  {id:'bandana', handle:'doggie-bandana', frameMM:340, name:'The Doggie Bandana', sub:'Doggie Skins cotton bandana · white', dark:false,
   places:{'Center front':{x:50,y:41.5,mm:100,mmMax:110,r:0}}},
  {id:'napkins', handle:'cocktail-napkins', frameMM:330, name:'The Cocktail Napkins', sub:'Hemstitched linen · set of four', dark:false,
   places:{'Center':{x:50,y:50,mm:70,mmMax:70,r:0},'Corner':{x:56.5,y:60,mm:45,mmMax:70,r:0}}}
];

const OCCASIONS=[
  {t:'Weddings',  s:'The party, getting ready',   pid:'sweatshirt'},
  {t:'New Baby',  s:'A first gift, kept',         pid:'bib'},
  {t:'The Dog',   s:'Named, and worn to the beach',pid:'bandana'},
  {t:'Hosting',   s:'Linens for the bar cart',    pid:'napkins'}
];
/* Merge the live store into the design config; anything not yet imported is dropped. */
PRODUCTS.forEach(p=>{const s=SHOP[p.handle];
  if(s&&s.variants&&s.variants.length){p.name=s.title;p.price=s.price/100;p.images=s.images;
    p.variants=s.variants;p.available=s.available;
    /* A colourway only exists if the live store actually carries a variant for it.
       Before the products are restructured there are no colour variants at all, and the
       picker must stay hidden rather than offer a blank that cannot be bought. */
    if(p.colors){
      const parts=v=>String(v.title||'').split('/').map(x=>x.trim().toLowerCase());
      p.activeColors=p.colors.filter(c=>p.variants.some(v=>parts(v).includes(c.name.toLowerCase())));
      if(!p.activeColors.length) p.activeColors=null;
    }}
  else p.missing=true;});
for(let i=PRODUCTS.length-1;i>=0;i--) if(PRODUCTS[i].missing) PRODUCTS.splice(i,1);

const S={saved:[],pid:'sweatshirt',name:'',style:'script',thread:'navy',place:null,size:'m',size2:'M',color:null,logo:null,design:null,lmode:'color',bag:[],zoom:false};
const SAMPLE='Avery'; /* shown in the preview until the customer types — never added to the bag */
const isMobile=()=>window.matchMedia('(max-width:1080px)').matches;

/* ---------- analytics: one function, three sinks ----------
   Shopify custom pixels (Settings → Customer events) can subscribe to every 'faro_*' event.
   GA4 via gtag and GTM via dataLayer pick them up too if they are installed. */
function track(name,data){
  const d=Object.assign({page:'home'},data||{});
  try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish(name,d); }catch(_){}
  try{ (window.dataLayer=window.dataLayer||[]).push(Object.assign({event:name},d)); }catch(_){}
  try{ if(typeof window.gtag==='function') gtag('event',name,d); }catch(_){}
}
const trackOnce=(()=>{const seen={};return (n,d)=>{if(seen[n])return;seen[n]=1;track(n,d);};})();
const FONTS={block:'Block',script:'Script',times:'Times Roman',classroom:'Classroom'};
const fontName=k=>FONTS[k]||'Script';
const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const P=()=>PRODUCTS.find(p=>p.id===S.pid);
/* the colourways the store can actually sell today, or null */
const colorsOf=p=>(p&&p.activeColors&&p.activeColors.length)?p.activeColors:null;
/* the selected colour object for the current piece, or null if the piece has no colours */
const C=()=>{const cs=colorsOf(P()); if(!cs) return null; return cs.find(c=>c.id===S.color)||cs[0];};
const colorName=()=>{const c=C(); return c?c.name:null;};
const T=()=>THREADS.find(t=>t.id===S.thread);
const money=n=>'$'+n.toFixed(2).replace(/\.00$/,'');

/* ---------- studio ---------- */
const stage=document.getElementById('stage'), baseImg=document.getElementById('baseImg'),
      zone=document.getElementById('zone'), txt=document.getElementById('stitchTxt'),
      svg=document.getElementById('zoneSvg');

/* The photo on the stage. For a piece with colourways, use the chosen colour's own
   variant image so the preview shows the blank the customer is actually buying.
   Falls back to the product's first photo if that variant carries no image. */
function baseSrc(p,z){
  if(colorsOf(p)){
    const cn=colorName();
    const v=(p.variants||[]).find(x=>String(x.title||'').split('/').map(s=>s.trim())
      .some(pt=>pt.toLowerCase()===String(cn).toLowerCase()));
    if(v&&v.image) return v.image;
  }
  return pimg(p,(z&&z.imgIndex)||0);
}
const SIZEMULT={s:.80,m:1,l:1.26};
let LAST_MM=0;
let curImg=null;
function setBase(key){
  if(curImg===key||!key) return;
  curImg=key; stage.classList.remove('ready');
  const im=new Image();
  im.onload=()=>{baseImg.src=im.src;baseImg.alt=P().name+' shown with your personalization';stage.classList.add('ready');};
  im.onerror=()=>{stage.classList.add('ready');
    const l=stage.querySelector('.loading');
    if(l){l.textContent='Image unavailable — reload the page';l.style.opacity=1;}};
  im.src=key;
}
function paint(){
  const p=P(), t=T();
  if(!p) return;
  if(!p.places[S.place]) S.place=Object.keys(p.places)[0];
  const z=p.places[S.place];
  setBase(baseSrc(p,z));
  stage.style.setProperty('--zx',z.x+'%');
  stage.style.setProperty('--zy',z.y+'%');
  stage.style.setProperty('--zr',(z.r||0)+'deg');
  document.querySelector('#threadLogo feFlood').setAttribute('flood-color',t.hex);

  const mult=SIZEMULT[S.size]||1;
  const logoEl=document.getElementById('stitchLogo');
  let w, mmW;

  if(S.logo){
    zone.style.opacity=1;
    txt.style.display='none'; logoEl.style.display='';
    logoEl.setAttribute('href',S.logo.src);
    logoEl.setAttributeNS('http://www.w3.org/1999/xlink','href',S.logo.src);
    const ar=S.logo.h/S.logo.w, H=600*ar;
    svg.setAttribute('viewBox','0 0 600 '+H.toFixed(0));
    logoEl.setAttribute('width',600); logoEl.setAttribute('height',H.toFixed(0));
    logoEl.setAttribute('filter', S.lmode==='thread'?'url(#threadLogo)':'url(#threadRaw)');
    mmW=Math.min(z.mm*1.35*mult, z.mmMax, HOOP.maxW);
    w=mmW/p.frameMM*100;
    zone.className='zone '+(S.lmode==='thread'
      ? (t.light?(p.dark?'screen':'normal'):(p.dark?'normal':'multiply'))
      : 'normal');
  }else{
    logoEl.style.display='none'; txt.style.display='';
    const nm=S.name||SAMPLE;
    txt.textContent=nm;
    zone.style.opacity=1;
    txt.setAttribute('fill',t.hex);
    txt.setAttribute('class','stitchtxt'+(S.style==='script'?'':' '+S.style));
    /* grows with the name, then hits the fabric's hard limit and scales down instead */
    const len=Math.max(1,nm.length);
    mmW=Math.min(z.mm*Math.pow(len/6,0.62)*mult, z.mmMax, HOOP.maxW);
    w=mmW/p.frameMM*100;
    zone.className='zone '+(t.light?(p.dark?'screen':'normal'):(p.dark?'normal':'multiply'));
    requestAnimationFrame(()=>{
      try{const b=txt.getBBox(); if(b.width>0) svg.setAttribute('viewBox',(b.x-14)+' '+(b.y-14)+' '+(b.width+28)+' '+(b.height+28));}catch(_){}
    });
  }
  stage.style.setProperty('--zw',w.toFixed(1)+'%');
  stage.classList.toggle('issample', !S.logo && !S.name);
  LAST_MM=mmW;
  const cappedBy = (mmW>=z.mmMax-0.5) ? (z.mmMax>=HOOP.maxW?'hoop':'panel') : null;
  document.getElementById('mmOut').innerHTML =
    Math.round(mmW)+' mm <span style="opacity:.6">('+(mmW/25.4).toFixed(1)+' in) wide</span>'+
    (cappedBy==='hoop' ? ' <span class="capnote">— at our '+HOOP.label+' maximum</span>'
     : cappedBy==='panel' ? ' <span class="capnote">— largest that fits this placement</span>' : '');

  const ls=document.getElementById('liveStrip');
  if(ls){
    const what = S.logo ? (S.design?esc(S.design.title):'Custom logo') : (S.name ? '&ldquo;<em>'+esc(S.name)+'</em>&rdquo;' : '<b>Type a name above</b> to stitch it');
    ls.innerHTML = what+' on <b>'+esc(p.name)+'</b>'+(p.sizes?' &middot; '+esc(S.size2):'')+' &middot; '+(S.logo?'':esc(fontName(S.style))+' &middot; ')+esc(t.name)+' thread &middot; '+esc(S.place);
  }
  document.getElementById('pName').textContent=p.name;
  document.getElementById('pSub').textContent=p.sub;
  document.getElementById('pPriceTop').textContent=money(p.price);
  document.getElementById('thName').textContent=t.name;

  const n=(S.name||'').length, MAXC=20;
  document.getElementById('cNum').textContent=n+' / '+MAXC;
  const help=document.getElementById('cHelp');
  if(S.logo){help.textContent=(S.design?S.design.title:'Your logo')+' is stitched — text hidden';help.className='';}
  else if(n>=MAXC){help.textContent='At the limit — longer text becomes a custom order';help.className='over';}
  else if(cappedBy && n>8){help.textContent='Scaled to fit the stitch area';help.className='';}
  else if(n===0){help.textContent='Included at no extra cost — type a name to begin';help.className='';}
  else{help.textContent='Included at no extra cost';help.className='';}
  const add=document.getElementById('addBtn');
  add.disabled = (n===0 && !S.logo);
  if(!add.dataset.busy) add.textContent = add.disabled ? 'Add to bag' : 'Add to bag · '+money(p.price);
  const cal=document.getElementById('calib'); if(cal && cal.classList.contains('on')) syncCalib();
}
function loadProduct(id,keepPlace){
  if(!PRODUCTS.some(p=>p.id===id)) return;
  S.pid=id; const p=P();
  if(!keepPlace||!p.places[S.place]) S.place=Object.keys(p.places)[0];
  if(p.sizes && !p.sizes.includes(S.size2)) S.size2=p.sizes[Math.min(2,p.sizes.length-1)];
  const cs=colorsOf(p);
  S.color = cs ? ((cs.some(c=>c.id===S.color)&&S.color)||cs[0].id) : null;
  renderPlaces(); renderSizes(); renderColors(); renderThumbs(); paint();
}
function renderThumbs(){
  document.getElementById('thumbs').innerHTML=PRODUCTS.map(p=>
    `<button class="thumb" data-pid="${p.id}" aria-pressed="${p.id===S.pid}" aria-label="${esc(p.name)}"><img src="${pimg(p,0,200)}" alt="" loading="lazy" width="200" height="250"></button>`).join('');
}
function renderSizes(){
  const p=P(), wrap=document.getElementById('sizeWrap');
  if(!p.sizes){wrap.hidden=true;return;}
  wrap.hidden=false;
  document.getElementById('garmentSizes').innerHTML=p.sizes.map(s=>
    `<button class="opt" data-gsize="${s}" aria-pressed="${s===S.size2}">${s}</button>`).join('');
}
function renderColors(){
  const p=P(), wrap=document.getElementById('colorWrap'), cs=colorsOf(p);
  if(!cs){wrap.hidden=true;return;}
  wrap.hidden=false;
  const parts=v=>String(v.title||'').split('/').map(x=>x.trim().toLowerCase());
  document.getElementById('blankColors').innerHTML=cs.map(c=>{
    const v=(p.variants||[]).find(x=>parts(x).includes(c.name.toLowerCase()));
    const out=!!(v&&v.available===false);
    return `<button class="opt copt${out?' soldout':''}" data-color="${c.id}" aria-pressed="${c.id===S.color}"${out?' disabled aria-disabled="true"':''}>`
      +`<i class="cdot" style="--c:${c.hex};--t:${c.trim||c.hex}"></i>${esc(c.name)}${out?' &middot; sold out':''}</button>`;
  }).join('');
}
function renderPlaces(){
  const p=P();
  document.getElementById('places').innerHTML=Object.keys(p.places).map(k=>
    `<button class="opt" data-place="${esc(k)}" aria-pressed="${k===S.place}">${esc(k)}</button>`).join('');
}
document.getElementById('threads').innerHTML=THREADS.map(t=>
  `<button class="sw" style="--c:${t.hex}" data-th="${t.id}" aria-pressed="${t.id===S.thread}" aria-label="${t.name}"></button>`).join('');

document.addEventListener('click',e=>{
  const th=e.target.closest('[data-th]');
  if(th){S.thread=th.dataset.th;document.querySelectorAll('[data-th]').forEach(b=>b.setAttribute('aria-pressed',b===th));paint();track('faro_thread',{thread:S.thread,piece:S.pid});return;}
  const st=e.target.closest('[data-style]');
  if(st){S.style=st.dataset.style;document.querySelectorAll('[data-style]').forEach(b=>b.setAttribute('aria-pressed',b===st));paint();track('faro_font',{font:S.style,piece:S.pid});return;}
  const pl=e.target.closest('[data-place]');
  if(pl){S.place=pl.dataset.place;document.querySelectorAll('[data-place]').forEach(b=>b.setAttribute('aria-pressed',b===pl));paint();track('faro_placement',{placement:S.place,piece:S.pid});return;}
  const gs=e.target.closest('[data-gsize]');
  if(gs){S.size2=gs.dataset.gsize;document.querySelectorAll('[data-gsize]').forEach(b=>b.setAttribute('aria-pressed',b===gs));paint();track('faro_size',{size:S.size2,piece:S.pid});return;}
  const cl=e.target.closest('[data-color]');
  if(cl){S.color=cl.dataset.color;document.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',b===cl));paint();track('faro_color',{color:S.color,piece:S.pid});return;}
  const sz=e.target.closest('[data-size]');
  if(sz){S.size=sz.dataset.size;document.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',b===sz));paint();return;}
  const lm=e.target.closest('[data-lmode]');
  if(lm){S.lmode=lm.dataset.lmode;document.querySelectorAll('[data-lmode]').forEach(b=>b.setAttribute('aria-pressed',b===lm));paint();return;}
  const tb=e.target.closest('[data-pid]');
  if(tb){if(tb.tagName==='A') e.preventDefault(); loadProduct(tb.dataset.pid); track('faro_piece',{piece:tb.dataset.pid,from:tb.classList.contains('thumb')?'thumb':(tb.closest('.fy')?'foryou':(tb.closest('.occ')?'occasion':(tb.closest('.tile')?'rail':'other')))}); if(!tb.classList.contains('thumb')) document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'});return;}
});
document.getElementById('nm').addEventListener('input',e=>{
  const v=e.target.value.slice(0,20);
  if(e.target.value.length>20) e.target.value=v;
  S.name=v; paint();
  if(v.length===1) trackOnce('faro_name_started',{piece:S.pid});
});
document.getElementById('zoomBtn').addEventListener('click',e=>{
  S.zoom=!S.zoom;stage.classList.toggle('zoom',S.zoom);
  e.currentTarget.setAttribute('aria-pressed',S.zoom);
  e.currentTarget.classList.toggle('act',S.zoom);
  e.currentTarget.textContent=S.zoom?'Exit zoom':'Zoom stitch';
});

/* ---------- design library ---------- */
const DESIGNS=(window.FARO_DESIGNS||[]).filter(d=>d&&d.title);
function shortTitle(t){
  return String(t).split(' Machine Embroidery')[0].split(' | ')[0].trim();
}
(function renderLibrary(){
  const g=document.getElementById('lgrid');
  if(!g) return;
  if(!DESIGNS.length){ const s=g.closest('section'); if(s) s.style.display='none'; return; }
  /* one source of truth: the theme setting. Split on the middot the setting uses. */
  const FORMATS=String(window.FARO_FORMATS||'DST · EXP · JEF · PES · VP3')
    .split(/[·,|]/).map(s=>s.trim()).filter(Boolean);
  g.innerHTML=DESIGNS.map((d,i)=>`
    <article class="lc">
      <div class="ph">${d.image?`<img src="${d.image}" alt="${esc(shortTitle(d.title))} embroidery design" loading="lazy" width="700" height="700">`:''}</div>
      <div class="bd">
        <div class="n">${esc(shortTitle(d.title))}</div>
        <div class="fm">${FORMATS.map(f=>`<span>${f}</span>`).join('')}</div>
        <div class="acts">
          <a class="buy" href="${d.url}">Download ${money(d.price/100)}</a>
          <button class="stitchit" data-design="${i}">Have us stitch it &rarr;</button>
        </div>
      </div>
    </article>`).join('');
})();

/* Put a Faro design on the piece. The product PNGs are transparent, so they
   composite through the same thread filters the logo upload uses. */
function takeDesign(i){
  const d=DESIGNS[i]; if(!d||!d.image) return;
  const im=new Image();
  im.onload=()=>{
    S.logo={src:d.image,w:im.naturalWidth||600,h:im.naturalHeight||600,name:shortTitle(d.title)};
    S.logoFile=null;
    S.design={title:shortTitle(d.title),image:d.image,url:d.url};
    S.lmode='color';
    document.getElementById('logoName').textContent=shortTitle(d.title);
    document.getElementById('logoRow').hidden=false;
    document.querySelectorAll('[data-lmode]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.lmode==='color'));
    paint();
    document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'});
    toast(shortTitle(d.title)+' added — pick your piece and placement',false);
  };
  im.onerror=()=>toast('That design could not be loaded',false);
  im.src=d.image;
}
document.addEventListener('click',e=>{
  const b=e.target.closest('[data-design]');
  if(b){ takeDesign(parseInt(b.dataset.design,10)); }
});

/* ---------- collection rail ---------- */
document.getElementById('rail').innerHTML=PRODUCTS.map(p=>`
  <article class="tile">
    <div class="ph">
      <img src="${pimg(p,0,700)}" alt="${esc(p.name)}" loading="lazy" width="700" height="875">
      <div class="over"><button data-pid="${p.id}">Personalize</button></div>
    </div>
    <div class="cap"><span class="n">${esc(p.name)}</span><span class="pr">${money(p.price)}</span></div>
    <div class="cap2">${esc(p.sub)}</div>
  </article>`).join('');
const rail=document.getElementById('rail');
const step=()=>Math.min(rail.clientWidth*.8,380);
document.getElementById('next').onclick=()=>rail.scrollBy({left:step(),behavior:'smooth'});
document.getElementById('prev').onclick=()=>rail.scrollBy({left:-step(),behavior:'smooth'});

/* ---------- occasions ---------- */
document.getElementById('occ').innerHTML=OCCASIONS.filter(o=>PRODUCTS.some(p=>p.id===o.pid)).map(o=>`
  <a href="#studio" data-pid="${o.pid}"><img src="${pimg(PRODUCTS.find(p=>p.id===o.pid),0,700)}" alt="" loading="lazy" width="700" height="875">
    <span class="lb"><span class="t dsp" style="color:inherit;display:block">${o.t}</span><span class="s">${o.s}</span></span>
  </a>`).join('');

/* ---------- Shopify cart (real orders, real checkout) ---------- */
const FREE=window.FARO_FREE_SHIP||7500; /* cents — set in the theme editor; must match the store's free-shipping rate */
let CART={items:[],total_price:0,item_count:0};

/* Variant titles differ depending on whether the product carries a Font option:
   "M"  (size only)  |  "M / Script"  (size + font)  |  "Script" (font only, one-size pieces).
   Match on the parts so the studio keeps working through the product change. */
function variantFor(p){
  if(!p.variants||!p.variants.length) return null;
  const font=fontName(S.style),
        size=p.sizes?S.size2:null,
        col=colorName();
  const parts=v=>String(v.title||'').split('/').map(x=>x.trim());
  const has=(v,x)=>parts(v).some(pt=>pt.toLowerCase()===String(x).toLowerCase());
  /* The real inventory dimensions are size and colour. Font is a line-item property,
     not a variant — but older products may still carry a Font option, so match on the
     dimensions first and then prefer a variant that is actually in stock. That is what
     keeps the studio working either side of the product change. */
  const dims=v=>(!size||has(v,size)) && (!col||has(v,col));
  const cands=p.variants.filter(dims);
  if(cands.length){
    return cands.find(v=>v.available&&has(v,font))
        || cands.find(v=>v.available)
        || cands.find(v=>has(v,font))
        || cands[0];
  }
  if(size){ const m=p.variants.find(v=>has(v,size)&&v.available)||p.variants.find(v=>has(v,size)); if(m) return m; }
  const m=p.variants.find(v=>has(v,font));
  if(m) return m;
  return p.variants.find(v=>v.available)||p.variants[0];
}
function lineProps(){
  const t=T(), cn=colorName(), o={
    'Name': S.design?('Faro design — '+S.design.title):(S.logo?'Custom logo':S.name),
    'Thread': t.name,
    'Placement': S.place,
    'Font': fontName(S.style),
    'Stitch width': Math.round(LAST_MM)+' mm'
  };
  if(cn) o['Blank colour']=cn;
  if(document.getElementById('isGift').checked){
    o['Gift']='Yes';
    const n=document.getElementById('giftNote').value.trim();
    if(n) o['Gift note']=n;
  }
  if(S.design){ o['Design']=S.design.title; }
  o['_thread_hex']=t.hex;
  return o;
}
async function shopAdd(){
  const p=P(), v=variantFor(p);
  if(!v){toast('That size is unavailable — please choose another',false);return;}
  const btn=document.getElementById('addBtn'); btn.disabled=true; btn.dataset.busy='1'; btn.textContent='Adding…';
  try{
    const props=lineProps();
    let res;
    if(S.logo&&S.logoFile){
      const fd=new FormData();
      fd.append('id',v.id); fd.append('quantity',1);
      Object.entries(props).forEach(([k,val])=>fd.append('properties['+k+']',val));
      fd.append('properties[Logo]',S.logoFile);
      res=await fetch('/cart/add.js',{method:'POST',body:fd});
    }else{
      res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})});
    }
    if(!res.ok){
      const e=await res.json().catch(()=>({}));
      console.error('[Faro] cart/add failed',res.status,e);
      throw new Error(e.description||e.message||'We could not add that to your bag. Please try again.');
    }
    await refreshCart();
    track('faro_add_to_bag',{piece:p.id,price:p.price,font:S.style,thread:S.thread,placement:S.place,mode:S.design?'design':(S.logo?'logo':'name')});
    toast('Added — '+p.name);
    const n=document.getElementById('cnum'); n.classList.add('pop'); setTimeout(()=>n.classList.remove('pop'),340);
  }catch(err){
    console.error('[Faro] add to bag',err);
    toast(err.message||'We could not add that to your bag. Please try again, or email us and we will place it for you.',false);
  }
  finally{ delete btn.dataset.busy; btn.disabled=false; paint(); }
}
document.getElementById('addBtn').addEventListener('click',()=>{
  if(!S.name&&!S.logo) return;
  shopAdd();
});
async function refreshCart(){
  try{
    const r=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    if(!r.ok) throw new Error('cart.js '+r.status);
    CART=await r.json();
  }catch(err){ console.warn('[Faro] cart refresh failed, keeping last known bag',err); }
  bagUI();
}
async function changeLine(key,qty){
  try{
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})});
    CART=await r.json();
  }catch(_){ }
  bagUI();
}
function bagUI(){
  document.getElementById('cnum').textContent=CART.item_count||0;
  const body=document.getElementById('cartBody'), foot=document.getElementById('cartFoot');
  if(!CART.items||!CART.items.length){
    body.innerHTML=`<div class="empty"><div class="dsp h-md">Your bag is empty</div><p>Every piece starts with a name.</p><button class="btn btn-line" data-close onclick="document.getElementById('studio').scrollIntoView({behavior:'smooth'})">Open the studio</button></div>`;
    foot.innerHTML=''; return;
  }
  const s=CART.total_price, left=Math.max(0,FREE-s);
  body.innerHTML=`<div class="ship">
      <div class="m">${left>0?`<b>${money(left/100)}</b> to complimentary shipping`:'<b>Complimentary shipping</b> unlocked'}</div>
      <div class="bar2"><i style="width:${Math.min(100,s/FREE*100)}%"></i></div>
    </div>`+
    CART.items.map(i=>{
      const pr=i.properties||{};
      const bits=[pr.Thread,pr.Placement,i.variant_title&&i.variant_title!=='Default Title'?'Size '+i.variant_title:''].filter(Boolean);
      return `<div class="ci">
        <div class="im">${i.image?`<img src="${i.image}" alt="" width="152" height="190">`:''}</div>
        <div class="in">
          <div class="n">${esc(i.product_title)}</div>
          <div class="v">${pr.Name?(pr.Name==='Custom logo'?'Custom logo':'“<em>'+esc(pr.Name)+'</em>”'):''}${bits.length?' · '+esc(bits.join(' · ')):''}</div>
          ${pr.Gift?`<div class="v" style="color:var(--beacon)">Gift${pr['Gift note']?' · “'+esc(pr['Gift note'])+'”':''}</div>`:''}
          <button class="rmv" data-key="${i.key}" data-qty="0">Remove</button>
          <div class="row">
            <div class="qty"><button data-key="${i.key}" data-qty="${i.quantity-1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-key="${i.key}" data-qty="${i.quantity+1}" aria-label="Increase">+</button></div>
            <span class="pr">${money(i.final_line_price/100)}</span>
          </div>
        </div></div>`;}).join('');
  foot.innerHTML=`<div class="trow"><span>Shipping</span><span>${left<=0?'Complimentary':'Calculated at checkout'}</span></div>
    <div class="trow b"><span>Subtotal</span><span>${money(s/100)}</span></div>
    <button class="btn btn-solid btn-blk" id="ck">Checkout</button>
    <div class="fine">Personalization included · proof before production<br>Arrives ${etaRange()} &mdash; 7&ndash;10 business days to stitch, plus shipping</div>`;
  document.getElementById('ck').onclick=()=>{track('faro_checkout',{items:CART.item_count,subtotal:s/100});window.location.href='/checkout';};
  renderXsell(body);
}
/* one gentle cross-sell in the bag: the first piece not already in it */
function renderXsell(body){
  const inBag=new Set((CART.items||[]).map(i=>String(i.product_id)));
  const pick=PRODUCTS.find(p=>{const s=SHOP[p.handle];return s&&!inBag.has(String(s.id));});
  if(!pick) return;
  const el=document.createElement('div'); el.className='xsell';
  el.innerHTML=`<div class="im"><img src="${pimg(pick,0,200)}" alt="" width="52" height="65"></div>
    <div class="t"><div class="k">Pairs well with</div><div class="n">${esc(pick.name)}</div><div class="pr">${money(pick.price)} · name included</div></div>
    <button type="button" data-xsell="${pick.id}">Personalize</button>`;
  body.appendChild(el);
}
document.addEventListener('click',e=>{
  const x=e.target.closest('[data-xsell]'); if(!x) return;
  track('faro_xsell_click',{piece:x.dataset.xsell});
  closeAll(); loadProduct(x.dataset.xsell);
  document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'});
});
document.addEventListener('click',e=>{
  const b=e.target.closest('[data-key]');
  if(b) changeLine(b.dataset.key, parseInt(b.dataset.qty,10));
});

/* ---------- drawers / nav ---------- */
const scrim=document.getElementById('scrim'),cart=document.getElementById('cart'),mnav=document.getElementById('mnav');
let lastF=null, lockY=0;
/* iOS keeps scrolling the page behind a drawer unless the body is pinned */
function lock(on){
  if(on){ if(document.body.classList.contains('locked')) return; lockY=scrollY; document.body.style.top=(-lockY)+'px'; document.body.classList.add('locked'); }
  else{ if(!document.body.classList.contains('locked')) return; document.body.classList.remove('locked'); document.body.style.top=''; scrollTo({top:lockY,behavior:'instant'}); }
}
function openCart(){lastF=document.activeElement;scrim.classList.add('on');cart.classList.add('on');lock(true);cart.querySelector('.xc').focus();track('faro_cart_open',{items:CART.item_count||0});}
function closeAll(){scrim.classList.remove('on');cart.classList.remove('on');mnav.classList.remove('on');
  const md=document.getElementById('modal'); if(md) md.classList.remove('on');
  document.getElementById('burger').setAttribute('aria-expanded','false');lock(false);if(lastF)lastF.focus();}
document.getElementById('openCart').onclick=openCart;
scrim.onclick=closeAll;
document.addEventListener('click',e=>{if(e.target.closest('[data-close]'))closeAll();});
document.addEventListener('keydown',e=>{
  if(e.key==='Escape'){closeAll();return;}
  if(e.key!=='Tab') return;
  const md=document.getElementById('modal');
  const open=cart.classList.contains('on')?cart:(mnav.classList.contains('on')?mnav:((md&&md.classList.contains('on'))?md:null));
  if(!open) return;
  const f=[...open.querySelectorAll('a[href],button:not([disabled]),input,select,textarea')]
    .filter(el=>el.offsetParent!==null);
  if(!f.length) return;
  const first=f[0], last=f[f.length-1];
  if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
  else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
});
document.getElementById('burger').onclick=e=>{
  const on=mnav.classList.toggle('on');
  e.currentTarget.setAttribute('aria-expanded',on);
  hdr.classList.remove('hide');
  lock(on);
};
mnav.addEventListener('click',e=>{if(e.target.tagName==='A')closeAll();});

/* toast */
let tT;
function toast(m,showBag=true){
  document.getElementById('tMsg').textContent=m;
  document.getElementById('tGo').style.display=showBag?'':'none';
  const el=document.getElementById('toast');el.classList.add('on');
  clearTimeout(tT);tT=setTimeout(()=>el.classList.remove('on'),3600);
}
document.getElementById('tGo').onclick=()=>{document.getElementById('toast').classList.remove('on');openCart();};
/* header behavior */
const hdr=document.getElementById('hdr');let lastY=0;
const studioEl=document.getElementById('studio');
addEventListener('scroll',()=>{
  if(document.body.classList.contains('locked')) return;
  const y=scrollY;
  const past=y>innerHeight-90;
  hdr.classList.toggle('solid',past);
  hdr.classList.toggle('light',!past);
  /* on a phone the preview is pinned to the top of the screen while the customer is inside the studio,
     so the header stays out of the way there in both scroll directions */
  const inStudio = isMobile() && y>studioEl.offsetTop-20 && y<studioEl.offsetTop+studioEl.offsetHeight-innerHeight*.6;
  const menuOpen = mnav.classList.contains('on') || cart.classList.contains('on');
  hdr.classList.toggle('hide', !menuOpen && ((y>lastY && y>innerHeight*1.2) || inStudio));
  lastY=y;
},{passive:true});

/* reveals */
const io=new IntersectionObserver(es=>es.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* ---------- calibration panel (press C) ---------- */
const calib=document.getElementById('calib');
const rx=document.getElementById('rx'),ry=document.getElementById('ry'),rw=document.getElementById('rw'),rr=document.getElementById('rr');
function syncCalib(){
  const z=P().places[S.place];
  rx.value=z.x;ry.value=z.y;rw.value=z.mm;rr.value=z.r||0;
  vx.textContent=z.x+'%';vy.textContent=z.y+'%';vw.textContent=z.mm+' mm';vr.textContent=(z.r||0)+'°';
  document.getElementById('calProd').textContent=P().id+' / '+S.place;
  document.getElementById('calOut').textContent=`'${S.place}':{x:${z.x},y:${z.y},mm:${z.mm},mmMax:${z.mmMax},r:${z.r||0}}`;
}
[rx,ry,rw,rr].forEach(r=>r.addEventListener('input',()=>{
  const z=P().places[S.place];
  z.x=+rx.value;z.y=+ry.value;z.mm=+rw.value;z.r=+rr.value;
  paint();syncCalib();
}));
/* Only Dana sees this: theme-editor preview, or ?calib=1 on the URL. Customers never do. */
const CALIB_OK = window.FARO_DEV===true || /[?&]calib=1/.test(location.search);
addEventListener('keydown',e=>{
  if(CALIB_OK && e.key.toLowerCase()==='c' && !/input|textarea/i.test(e.target.tagName)){
    calib.classList.toggle('on'); if(calib.classList.contains('on')) syncCalib();
  }
});

/* ---------- logo upload ---------- */
const fileIn=document.getElementById('logoFile'), drop=document.getElementById('drop'),
      logoRow=document.getElementById('logoRow');
document.getElementById('upBtn').onclick=()=>fileIn.click();
fileIn.onchange=e=>{ if(e.target.files[0]) takeLogo(e.target.files[0]); };
['dragenter','dragover'].forEach(ev=>drop.addEventListener(ev,e=>{e.preventDefault();drop.classList.add('drag');}));
['dragleave','drop'].forEach(ev=>drop.addEventListener(ev,e=>{e.preventDefault();drop.classList.remove('drag');}));
drop.addEventListener('drop',e=>{ const f=e.dataTransfer.files[0]; if(f) takeLogo(f); });

function takeLogo(file){
  if(!/^image\/(png|svg\+xml)$/.test(file.type)){ toast('Upload a PNG or SVG file',false); return; }
  if(file.size>5*1024*1024){ toast('That file is over 5 MB — please send a smaller one',false); return; }
  const fr=new FileReader();
  fr.onload=()=>{
    const im=new Image();
    im.onload=()=>{
      S.logo={src:fr.result,w:im.naturalWidth||600,h:im.naturalHeight||200,name:file.name};
      S.logoFile=file; S.design=null;
      document.getElementById('logoName').textContent=file.name;
      logoRow.hidden=false; paint();
      toast('Logo added — we will digitize it before stitching',false);
    };
    im.onerror=()=>toast('That image could not be read',false);
    im.src=fr.result;
  };
  fr.onerror=()=>toast('That file could not be read',false);
  fr.readAsDataURL(file);
}
document.getElementById('rmLogo').onclick=()=>{
  S.logo=null; S.logoFile=null; S.design=null; logoRow.hidden=true; fileIn.value=''; paint();
};

/* ---------- saved designs ----------
   Kept in this browser's localStorage so they survive a reload and a return visit on the same
   device. Uploaded logos are large data URLs and are not persisted; Faro library designs are. */
const SAVE_KEY='faro.saved.v1';
function persistSaved(){
  try{
    const slim=S.saved.map(d=>Object.assign({},d,{logo:(d.logo&&d.design)?d.logo:null}));
    localStorage.setItem(SAVE_KEY,JSON.stringify(slim));
  }catch(_){}
}
function restoreSaved(){
  try{
    const raw=localStorage.getItem(SAVE_KEY); if(!raw) return;
    const arr=JSON.parse(raw); if(!Array.isArray(arr)) return;
    S.saved=arr.filter(d=>d&&(d.name||d.logo)&&PRODUCTS.some(p=>p.id===d.pid)&&THREADS.some(t=>t.id===d.thread)).slice(0,12);
  }catch(_){}
}
function syncControls(){
  document.getElementById('nm').value=S.name;
  document.querySelectorAll('[data-style]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.style===S.style));
  document.querySelectorAll('[data-th]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.th===S.thread));
  document.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.size===S.size));
  document.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.color===S.color));
  document.querySelectorAll('[data-lmode]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.lmode===S.lmode));
  const lr=document.getElementById('logoRow');
  if(S.logo){lr.hidden=false;document.getElementById('logoName').textContent=(S.design?S.design.title:S.logo.name);}
  else{lr.hidden=true;}
}
function renderSaved(){
  const wrap=document.getElementById('savedWrap'), rail=document.getElementById('savedRail');
  if(!S.saved.length){wrap.hidden=true;rail.innerHTML='';return;}
  wrap.hidden=false;
  rail.innerHTML=S.saved.map(d=>{
    const p=PRODUCTS.find(x=>x.id===d.pid), t=THREADS.find(x=>x.id===d.thread);
    const cls={block:'blk',times:'tms',classroom:'cls'}[d.style]||'';
    const label=d.design?esc(d.design.title):(d.logo?'Custom logo':esc(d.name));
    return `<div class="sd">
      <button class="sdmain" data-use="${d.id}" aria-label="Load ${esc(label)}">
        <span class="sdname ${d.logo?'blk':cls}" style="color:${t.hex}">${label}</span>
        <span class="sdmeta">${esc(p.name)}<br>${t.name} · ${esc(d.place)}${d.size2?' · '+esc(d.size2):''}</span>
      </button>
      <div class="sdacts">
        <button data-reorder="${d.id}">Add to bag</button>
        <button data-del="${d.id}">Remove</button>
      </div></div>`;}).join('');
}
function saveDesign(){
  if(!S.name && !S.logo){toast('Add a name, a design, or a logo first',false);return;}
  const p=P();
  S.saved.unshift({id:'d'+Date.now(),pid:S.pid,name:S.name,style:S.style,thread:S.thread,
    place:S.place,size:S.size,size2:p.sizes?S.size2:'',logo:S.logo,design:S.design,lmode:S.lmode});
  persistSaved(); renderSaved(); toast('Design saved on this device — reorder it any time',false);
  track('faro_design_saved',{piece:S.pid,font:S.style,thread:S.thread});
}
function useDesign(id){
  const d=S.saved.find(x=>x.id===id); if(!d) return;
  Object.assign(S,{pid:d.pid,name:d.name,style:d.style,thread:d.thread,place:d.place,
    size:d.size,size2:d.size2||S.size2,logo:d.logo,design:d.design||null,lmode:d.lmode});
  loadProduct(d.pid,true); syncControls(); paint();
  document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'});
}
document.getElementById('saveBtn').onclick=saveDesign;
document.addEventListener('click',e=>{
  const u=e.target.closest('[data-use]');    if(u){useDesign(u.dataset.use);return;}
  const r=e.target.closest('[data-reorder]');if(r){useDesign(r.dataset.reorder);
    setTimeout(()=>shopAdd(),120);return;}
  const x=e.target.closest('[data-del]');    if(x){S.saved=S.saved.filter(d=>d.id!==x.dataset.del);persistSaved();renderSaved();return;}
});

/* ---------- delivery estimate ---------- */
function addBiz(from,n){const d=new Date(from);let a=0;
  while(a<n){d.setDate(d.getDate()+1);const w=d.getDay();if(w!==0&&w!==6)a++;}return d;}
const FMT={month:'short',day:'numeric'};
function etaRange(){
  const a=addBiz(new Date(),9), b=addBiz(new Date(),14);
  return a.toLocaleDateString('en-US',FMT)+' – '+b.toLocaleDateString('en-US',FMT);
}
/* The 9/14 business-day window is DELIVERY. The 7-10 quoted everywhere else is
   STITCHING time from an approved proof. Say both, or the two numbers read as a
   contradiction on the same screen. */
document.getElementById('etaNote').textContent='Arrives '+etaRange()+' if you order today — 7–10 business days to stitch, plus shipping.';

/* ======================================================================
   v21 GROWTH LAYER — deep links, personas, need-by date, share / email
   my design, group-quote modal, floating CTA, welcome-back, funnel events
   ====================================================================== */

/* ---- design deep link: ?d=<base64 json> reopens the studio exactly as left ---- */
function designState(){
  return {pid:S.pid,name:S.name,style:S.style,thread:S.thread,place:S.place,size2:S.size2,
          di:(S.design&&DESIGNS.findIndex(x=>x.image===S.design.image))};
}
function designLink(){
  try{
    const raw=JSON.stringify(designState());
    const b64=btoa(unescape(encodeURIComponent(raw))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    const u=new URL(location.origin+location.pathname); u.searchParams.set('d',b64); u.hash='studio';
    return u.toString();
  }catch(_){ return location.origin+location.pathname+'#studio'; }
}
function designSummary(){
  const p=P(), t=T();
  return (S.design?('Faro design "'+S.design.title+'"'):(S.logo?'Custom logo':('"'+(S.name||'')+'"')))+' on '+p.name+
    (p.sizes?' (size '+S.size2+')':'')+' · '+(S.logo?'':fontName(S.style)+' · ')+t.name+' thread · '+S.place+(NEED.date?' · needed by '+NEED.date:'');
}
function applyDeepLink(){
  const q=new URLSearchParams(location.search);
  const d=q.get('d');
  if(d){
    try{
      const raw=decodeURIComponent(escape(atob(d.replace(/-/g,'+').replace(/_/g,'/'))));
      const o=JSON.parse(raw);
      if(o&&PRODUCTS.some(p=>p.id===o.pid)){
        Object.assign(S,{pid:o.pid,name:String(o.name||'').slice(0,20),style:FONTS[o.style]?o.style:'script',
          thread:THREADS.some(t=>t.id===o.thread)?o.thread:'navy',place:o.place||null,size2:o.size2||'M'});
        if(typeof o.di==='number'&&o.di>=0&&DESIGNS[o.di]) takeDesign(o.di);
        loadProduct(S.pid,true); syncControls(); paint();
        setTimeout(()=>document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'}),300);
        track('faro_deeplink_open',{piece:S.pid});
        return true;
      }
    }catch(_){}
  }
  return false;
}

/* ---- persona links: ?for=bride|baby|dog|host  (also from utm_content) ---- */
const PERSONA={bride:'sweatshirt',baby:'bib',dog:'bandana',host:'napkins'};
function applyPersona(){
  const q=new URLSearchParams(location.search);
  const f=(q.get('for')||q.get('utm_content')||'').toLowerCase();
  if(!PERSONA[f]) return false;
  const copy=(window.FARO_COPY||{})[f];
  const h1=document.querySelector('.hero h1');
  if(copy&&h1) h1.textContent=copy;
  if(PRODUCTS.some(p=>p.id===PERSONA[f])) loadProduct(PERSONA[f]);
  track('faro_persona',{persona:f,source:q.get('utm_source')||document.referrer.split('/')[2]||'direct'});
  return true;
}

/* ---- welcome back: a returning visitor with a saved design ---- */
function welcomeBack(){
  const wb=document.getElementById('wback'); if(!wb||!S.saved.length) return;
  wb.classList.add('on');
  document.getElementById('wbackGo').onclick=()=>{track('faro_welcome_back',{});useDesign(S.saved[0].id);wb.classList.remove('on');};
}

/* ---- need it by a date? ---- */
const NEED={date:''};
const needIn=document.getElementById('needBy'), needOut=document.getElementById('needOut'), needClear=document.getElementById('needClear');
function needByCheck(){
  const v=needIn.value; NEED.date=v;
  needClear.hidden=!v;
  if(!v){needOut.hidden=true;return;}
  const want=new Date(v+'T12:00:00');
  const early=addBiz(new Date(),9), late=addBiz(new Date(),14);
  const fmt=x=>x.toLocaleDateString('en-US',FMT);
  needOut.hidden=false;
  if(want>=late){ needOut.className='needout ok'; needOut.innerHTML='<b>Yes.</b> Order today and it arrives by '+fmt(late)+' at the latest — well before '+fmt(want)+'.'; track('faro_needby',{result:'ok'}); }
  else if(want>=early){ needOut.className='needout ok'; needOut.innerHTML='<b>Likely.</b> Standard turnaround lands '+fmt(early)+' – '+fmt(late)+'. Order today and approve your proof the same day to be safe.'; track('faro_needby',{result:'tight'}); }
  else { needOut.className='needout warn'; needOut.innerHTML='That is inside our standard 7–10 business days. Rush is sometimes possible — <button type="button" data-open="quote" data-rush="1">ask about a rush</button> and we will answer within a few hours.'; track('faro_needby',{result:'rush'}); }
}
needIn.addEventListener('change',needByCheck);
needClear.onclick=()=>{needIn.value='';needByCheck();};
/* the date rides along on the order line */
const _lineProps=lineProps;
lineProps=function(){const o=_lineProps(); if(NEED.date) o['Needed by']=NEED.date; return o;};

/* ---- share / email my design ---- */
document.getElementById('shareBtn').onclick=async()=>{
  if(!S.name&&!S.logo){toast('Type a name first, then share it',false);return;}
  const url=designLink(), text=designSummary()+' — Faro Embroidery';
  track('faro_share',{piece:S.pid});
  try{
    if(navigator.share){ await navigator.share({title:'My Faro design',text,url}); return; }
  }catch(_){ return; }
  try{ await navigator.clipboard.writeText(url); toast('Link copied — paste it anywhere',false); }
  catch(_){ prompt('Copy this link', url); }
};
document.getElementById('emailBtn').onclick=()=>{
  if(!S.name&&!S.logo){toast('Type a name first, then we can email it',false);return;}
  openModal('save');
};

/* ---- modal: group quote / rush / email my design ----------------------------
   ONE Shopify contact form, three modes. The form is always in the DOM — after a
   successful send Shopify reloads the page, we show a receipt AND leave the form
   usable, so a customer can immediately send a second request (e.g. email their
   design right after asking about a rush). */
const modal=document.getElementById('modal');
const MODES={quote:'Group quote',rush:'Rush request',save:'Email me my design'};

/* Reference: FARO-<mmdd>-<4 chars>. Goes in the email Dana receives AND on the
   customer's receipt, so one string ties both sides of the conversation together. */
function makeRef(){
  const d=new Date(), p=n=>String(n).padStart(2,'0');
  const A='ACDEFHJKLMNPRTUVWXY3479';
  let t=''; for(let i=0;i<4;i++) t+=A[Math.floor(Math.random()*A.length)];
  return 'FARO-'+p(d.getMonth()+1)+p(d.getDate())+'-'+t;
}
function fieldVal(id){const e=document.getElementById(id);return e?String(e.value||'').trim():'';}

/* what the customer sees, and what they can mail themselves */
function receiptRows(){
  const rows=[['Reference',fieldVal('cfRef')],['Request',fieldVal('cfRequest')],
    ['Name',fieldVal('cfName')],['Email',fieldVal('cfEmail')]];
  const q=fieldVal('cfQty'), dt=fieldVal('cfDate'), pc=fieldVal('cfPieces'),
        bd=fieldVal('cfBody'), dz=fieldVal('cfDesign'), lk=fieldVal('cfLink');
  const kind=fieldVal('cfRequest');
  if(kind!=='Email me my design'){
    if(q) rows.push(['How many',q]);
    if(dt) rows.push(['Needed by',dt]);
    if(pc) rows.push(['Pieces',pc]);
  }
  if(dz) rows.push(['Your design',dz]);
  if(lk) rows.push(['Reopen your design',lk]);
  if(bd) rows.push(['Notes',bd]);
  rows.push(['Sent',new Date().toLocaleString('en-US',{dateStyle:'medium',timeStyle:'short'})]);
  return rows.filter(r=>r[1]);
}
const PENDING_KEY='faro.request.v1';
function stashPending(){
  try{ localStorage.setItem(PENDING_KEY,JSON.stringify({rows:receiptRows(),ts:Date.now()})); }catch(_){}
}
function renderReceipt(data){
  const box=document.getElementById('receipt'); if(!box||!data||!data.rows) return false;
  const rows=data.rows, ref=(rows.find(r=>r[0]==='Reference')||[])[1]||'—';
  document.getElementById('rcRef').textContent=ref;
  document.getElementById('rcBody').innerHTML='<dl>'+rows.filter(r=>r[0]!=='Reference')
    .map(r=>'<dt>'+esc(r[0])+'</dt><dd>'+(r[0]==='Reopen your design'
      ? '<a href="'+esc(r[1])+'" style="color:var(--beacon);border-bottom:1px solid currentColor">Open my design &rarr;</a>'
      : esc(r[1]))+'</dd>').join('')+'</dl>';
  box.hidden=false;
  const bx=modal.querySelector('.box'); if(bx) bx.classList.add('hasreceipt');
  const asText=()=>rows.map(r=>r[0]+': '+r[1]).join('\n');
  document.getElementById('rcMail').onclick=()=>{
    const to=(rows.find(r=>r[0]==='Email')||[])[1]||'';
    track('faro_receipt_email',{});
    location.href='mailto:'+encodeURIComponent(to)
      +'?subject='+encodeURIComponent('My Faro Embroidery request — '+ref)
      +'&body='+encodeURIComponent('Keeping a copy of the request I sent to Faro Embroidery.\n\n'+asText()
        +'\n\nFaro replies from '+((window.FARO_COPY||{}).shopEmail||'')+' within one business day.');
  };
  document.getElementById('rcCopy').onclick=async()=>{
    track('faro_receipt_copy',{});
    try{ await navigator.clipboard.writeText(asText()); toast('Copied — paste it anywhere to keep it',false); }
    catch(_){ prompt('Copy your request', asText()); }
  };
  document.getElementById('rcNew').onclick=()=>{
    box.hidden=true; if(bx) bx.classList.remove('hasreceipt');
    try{ localStorage.removeItem(PENDING_KEY); }catch(_){}
    const f=document.getElementById('cfBody'); if(f) f.value='';
    openModal('quote');
  };
  return true;
}

function openModal(mode,opts){
  if(!modal) return;
  if(!MODES[mode]) mode='quote';
  modal.classList.remove('quote','rush','save'); modal.classList.add('on',mode);
  const req=document.getElementById('cfRequest'), des=document.getElementById('cfDesign'),
        lnk=document.getElementById('cfLink'), body=document.getElementById('cfBody'),
        ref=document.getElementById('cfRef');
  const hasDesign=!!(S.name||S.logo);
  if(req) req.value=MODES[mode];
  if(ref) ref.value=makeRef();
  if(des) des.value = hasDesign ? designSummary() : '';
  if(lnk) lnk.value = hasDesign ? designLink() : '';
  if(body){
    if(mode==='save') body.value='Please email me the link to my saved design: '+designLink();
    else if(mode==='rush') body.value='Rush request — needed by '+(NEED.date||'(date)')+'. Design: '+(hasDesign?designSummary():'(not chosen yet)');
  }
  const cfDate=document.getElementById('cfDate'); if(cfDate&&NEED.date&&!cfDate.value) cfDate.value=NEED.date;
  lastF=document.activeElement; lock(true);
  const first=document.getElementById('cfName'); if(first) setTimeout(()=>first.focus(),50);
  track(mode==='save'?'faro_email_design_open':'faro_quote_open',{mode:mode});
}
document.addEventListener('click',e=>{
  const o=e.target.closest('[data-open]'); if(!o) return;
  e.preventDefault();
  openModal(o.dataset.rush==='1' ? 'rush' : o.dataset.open);
});
if(modal){
  modal.addEventListener('click',e=>{ if(e.target===modal) closeAll(); });
  const cf=document.getElementById('faroContact');
  if(cf) cf.addEventListener('submit',()=>{
    stashPending();
    track(modal.classList.contains('save')?'faro_email_design_submit':'faro_quote_submit',
      {mode:modal.classList.contains('rush')?'rush':(modal.classList.contains('save')?'save':'quote')});
  });
  /* came back from a successful post — show the receipt over the (still usable) form */
  const posted = window.FARO_POSTED===1 || /[?&]contact_posted=true/.test(location.search);
  if(posted){
    let data=null; try{ data=JSON.parse(localStorage.getItem(PENDING_KEY)||'null'); }catch(_){}
    if(data && Date.now()-(data.ts||0) < 36e5) renderReceipt(data);
    else { const b=document.getElementById('receipt');
      if(b){ document.getElementById('rcRef').textContent='sent';
             document.getElementById('rcBody').innerHTML='<dl><dt>Status</dt><dd>Your request reached us. We reply within one business day.</dd></dl>';
             b.hidden=false; const bx=modal.querySelector('.box'); if(bx) bx.classList.add('hasreceipt');
             document.getElementById('rcMail').hidden=true; document.getElementById('rcCopy').hidden=true;
             document.getElementById('rcNew').onclick=()=>{b.hidden=true;if(bx)bx.classList.remove('hasreceipt');openModal('quote');}; } }
    modal.classList.add('on','quote'); lock(true);
    track('faro_request_confirmed',{});
  }
}
/* newsletter sign-up event (the form posts to Shopify; we just count the attempt) */
const nl=document.getElementById('faroSignup'); if(nl) nl.addEventListener('submit',()=>track('faro_newsletter_submit',{}));

/* ======================================================================
   HERO VIDEO — progressive enhancement, never a dependency
   ----------------------------------------------------------------------
   The still photograph is always in the DOM and is the LCP element. The
   video is a layer on top that starts at opacity 0 and is only revealed
   on the `playing` event. Every failure path — no video set, reduced
   motion, data saver, a slow radio, a blocked autoplay, a 404, a stall —
   ends with the photograph on screen and the <video> removed. We never
   give the element a src until after `load`, so it cannot compete with
   the hero image for bandwidth during first paint.
   ====================================================================== */
(function heroVideo(){
  const v = document.getElementById('heroVid');
  if(!v) return;                                   // still-only hero
  const MOBILE_Q = '(max-width:760px)';

  const conn = () => navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  /* Stable facts — safe to decide immediately. */
  function declinedEarly(){
    try{
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'reduced-motion';
    }catch(_){}
    const small = window.matchMedia(MOBILE_Q).matches;
    if(small && !v.dataset.srcMobile) return 'no-mobile-file';   // never ship the wide file to a phone
    if(!small && !v.dataset.src)      return 'no-desktop-file';
    return null;
  }

  /* DO NOT gate on estimated bandwidth. Both `effectiveType` and `downlink` are
     rolling estimates that are wrong early in a page load, and this is where the
     hero video decision has to be made. On the live site they produced two false
     refusals in a row on a fast connection: first effectiveType:'3g' (settling to
     4g a second later), then downlink:0.15 while effectiveType already said 4g.
     Predicting the connection was the mistake. We already MEASURE the real thing:
     if the file cannot arrive, `playing` never fires, the 8s timeout trips, and
     the photograph stays. That is self-correcting and needs no guesswork.
     Only `saveData` survives here, because it is an explicit user choice rather
     than an estimate. */
  function declinedNow(){
    const c = conn();
    if(c && c.saveData) return 'save-data';
    return null;
  }

  let settled = false;
  let timer = null;          /* declared before keepTheStill — it clears this */
  function keepTheStill(why){
    if(settled) return; settled = true;
    clearTimeout(timer);
    try{ v.pause(); v.removeAttribute('src'); v.load(); }catch(_){}
    if(v.parentNode) v.parentNode.removeChild(v);
    const c = conn();
    track('faro_hero_video',{state:'fallback',reason:why||'unknown',
      effectiveType:(c&&c.effectiveType)||'unknown', downlink:(c&&c.downlink)||null});
  }

  const early = declinedEarly();
  if(early){ keepTheStill(early); return; }

  const small = window.matchMedia(MOBILE_Q).matches;
  const src   = small ? v.dataset.srcMobile : v.dataset.src;

  function start(){
    if(settled) return;
    const late = declinedNow();
    if(late){ keepTheStill(late); return; }
    /* if it has not started within 8s, stop waiting and keep the photograph */
    timer = setTimeout(()=>keepTheStill('timeout'), 8000);
    v.addEventListener('error',  ()=>keepTheStill('error'),  {once:true});
    v.addEventListener('stalled',()=>keepTheStill('stalled'),{once:true});
    v.addEventListener('playing', function(){
      if(settled) return; settled = true;
      clearTimeout(timer);
      v.classList.add('on');
      track('faro_hero_video',{state:'playing',cut:small?'mobile':'desktop'});
    }, {once:true});

    /* Set muted as a PROPERTY, not just the markup attribute. Browsers gate
       autoplay on the property at play() time, and when the src is assigned
       dynamically the attribute alone is unreliable — this is the usual cause of
       an "autoplay-blocked" rejection on a video that is plainly muted. iOS also
       wants playsInline set as a property. */
    v.muted = true; v.defaultMuted = true; v.volume = 0;
    v.setAttribute('muted','');
    v.playsInline = true;

    v.src = src;
    try{ v.load(); }catch(_){}

    /* One retry: re-assert muted and try again before giving up, since the first
       rejection is often a timing artefact rather than a real policy block. */
    function attempt(retry){
      const p = v.play();
      if(!p || typeof p.catch !== 'function') return;
      p.catch(()=>{
        if(settled) return;
        if(retry){ v.muted = true; setTimeout(()=>attempt(false), 250); }
        else keepTheStill('autoplay-blocked');
      });
    }
    attempt(true);
  }

  /* wait until the page has loaded so the hero IMAGE wins the bandwidth first */
  function soon(fn){
    if(typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn,{timeout:1500});
    else setTimeout(fn,1);
  }
  function defer(fn){
    if(document.readyState === 'complete') soon(fn);
    else window.addEventListener('load', ()=>soon(fn), {once:true});
  }
  defer(start);

  /* stop decoding once the hero is scrolled away — this runs on every page view,
     so it is worth the battery on a phone */
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(es=>{
      es.forEach(e=>{
        if(settled && !v.parentNode) return;
        if(e.isIntersecting){ const p=v.play(); if(p&&p.catch) p.catch(()=>{}); }
        else v.pause();
      });
    },{threshold:0.01});
    io.observe(v);
  }
  document.addEventListener('visibilitychange',()=>{
    if(!v.parentNode) return;
    if(document.hidden) v.pause();
    else { const p=v.play(); if(p&&p.catch) p.catch(()=>{}); }
  });

  /* honour a motion preference switched on after load */
  try{
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = e => { if(e.matches) keepTheStill('reduced-motion'); };
    mq.addEventListener ? mq.addEventListener('change',onChange) : mq.addListener(onChange);
  }catch(_){}
})();

/* ---- floating "Personalize" pill on phones, outside the studio ---- */
const fab=document.getElementById('fab');
if(fab){
  fab.onclick=()=>{track('faro_fab_click',{});document.getElementById('studio').scrollIntoView({behavior:'smooth',block:'start'});};
  const fabTick=()=>{
    if(!isMobile()){fab.classList.remove('on');return;}
    const y=scrollY, st=studioEl.offsetTop, sb=st+studioEl.offsetHeight;
    const inStudio=y>st-innerHeight*.5 && y<sb-innerHeight*.4;
    const busy=document.body.classList.contains('locked');
    fab.classList.toggle('on', y>innerHeight*.9 && !inStudio && !busy);
  };
  addEventListener('scroll',fabTick,{passive:true}); addEventListener('resize',fabTick);
}

/* ---- funnel view events ---- */
(function(){
  const marks=[['#studio','faro_studio_view'],['#group','faro_group_view'],['#library','faro_library_view'],['footer','faro_footer_view']];
  const vio=new IntersectionObserver(es=>es.forEach(en=>{ if(en.isIntersecting){ trackOnce(en.target.dataset.ev,{}); vio.unobserve(en.target);} }),{threshold:.3});
  marks.forEach(([sel,ev])=>{const el=document.querySelector(sel); if(el){el.dataset.ev=ev; vio.observe(el);} });
})();

/* ---------- gift note ---------- */
const isGift=document.getElementById('isGift'), giftNote=document.getElementById('giftNote');
isGift.addEventListener('change',()=>{giftNote.hidden=!isGift.checked; if(isGift.checked) giftNote.focus();});

if(!PRODUCTS.length){
  const g=document.querySelector('.studio-grid');
  if(g) g.innerHTML='<div style="grid-column:1/-1;border:1px solid var(--rule);background:var(--sand);padding:38px">'+
    '<div class="dsp h-md">No products found in this store</div>'+
    '<p class="lede" style="margin-top:14px">The studio reads your Shopify catalogue by handle. Import '+
    '<b>Faro_Shopify_Products.csv</b>, then open each product and set its status to <b>Active</b> — '+
    'draft products are invisible to the storefront.</p>'+
    '<p class="lede" style="margin-top:12px">Expected handles: bridal-sweatshirt, coastal-tank, sweat-shorts, '+
    'baby-bib, waffle-spa-bag, doggie-bandana, cocktail-napkins.</p></div>';
  const rail=document.getElementById('rail'); if(rail) rail.innerHTML='';
  const occ=document.getElementById('occ'); if(occ) occ.closest('section').style.display='none';
}else{
  loadProduct(PRODUCTS[0].id);
}
restoreSaved(); refreshCart(); renderSaved();
if(PRODUCTS.length){ if(!applyDeepLink()){ applyPersona(); welcomeBack(); } }
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(()=>paint());}
